var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as categoryFactory from '../../../classes/definitions/brandCategory/brandCategory';
import { DropdownOption } from '../../../classes/definitions/formItem/ElementConfig';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import brandCategorySchema from '../../../schemas/brandCategorySchema';
import Input from '../../UI/Input/Input';
var BrandCategoryForm = /** @class */ (function (_super) {
    __extends(BrandCategoryForm, _super);
    function BrandCategoryForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.imageChanged = false;
        // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(brandCategorySchema),
            formIsValid: false,
            discardPopupVisble: false,
            parentSuggestions: [],
            brandId: 0,
            categoryId: 0
        };
        _this.getCategory = function (brand_id, id) {
            _this.api
                .getBrandCategory(brand_id, id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                console.log(error);
                var defaultMessage = 'Грешка при зареждане на маркова категорията';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var category = categoryFactory.createCategory(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'bg_name.value', category.BgName);
            _.set(updatedFormConfig, 'bg_name.touched', true);
            _.set(updatedFormConfig, 'bg_name.valid', true);
            _.set(updatedFormConfig, 'en_name.value', category.EnName);
            _.set(updatedFormConfig, 'en_name.touched', true);
            _.set(updatedFormConfig, 'en_name.valid', true);
            _.set(updatedFormConfig, 'slug.value', category.Slug);
            _.set(updatedFormConfig, 'slug.touched', true);
            _.set(updatedFormConfig, 'slug.valid', true);
            _.set(updatedFormConfig, 'position.value', category.Position ? category.Position : null);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _.set(updatedFormConfig, 'parent_id.value', category.ParentId);
            _.set(updatedFormConfig, 'parent_id.touched', true);
            _.set(updatedFormConfig, 'parent_id.valid', true);
            _.set(updatedFormConfig, 'hidden.value', category.Hidden);
            _.set(updatedFormConfig, 'hidden.touched', true);
            _.set(updatedFormConfig, 'hidden.valid', true);
            _.set(updatedFormConfig, 'meta_title.value', category.MetaTitle);
            _.set(updatedFormConfig, 'meta_title.touched', true);
            _.set(updatedFormConfig, 'meta_title.valid', true);
            _.set(updatedFormConfig, 'meta_description.value', category.MetaDescription);
            _.set(updatedFormConfig, 'meta_description.touched', true);
            _.set(updatedFormConfig, 'meta_description.valid', true);
            /*    _.set(updatedFormConfig, 'brand_hidden.value', category.BrandHidden);
               _.set(updatedFormConfig, 'brand_hidden.touched', true);
               _.set(updatedFormConfig, 'brand_hidden.valid', true); */
            // removing the field for parent id on edit
            delete updatedFormConfig.parent_id;
            console.log(_this.state.brandId);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            // The blur methods resets teh autocomplete for some reason
            if (id === 'parent_id' && eventType === 'onBlur') {
                return;
            }
            if (id !== 'hidden') {
                updatedFormElement.value = id !== 'parent_id' ? event.target.value : event.value;
            }
            else {
                updatedFormElement.value = event.checked;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            if (id === 'image' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var parentId = _.get(formData, 'parent_id.value.value', null);
            var image = _.get(formData, 'image.value', null);
            var submittedCategories = {
                "brand_category": {
                    "bg_name": _.get(formData, 'bg_name.value', ''),
                    "en_name": _.get(formData, 'en_name.value', ''),
                    "position": Number(_.get(formData, 'position.value', '')),
                    "brand_id": Number(_this.state.brandId),
                    "hidden": _.get(formData, 'hidden.value', ''),
                    "meta_title": _.get(formData, 'meta_title.value', ''),
                    "meta_description": _.get(formData, 'meta_description.value', ''),
                    "parent_id": parentId ? Number(_.get(formData, 'parent_id.value.value', null)) : null,
                    "slug": _.get(formData, 'slug.value', ''),
                }
            };
            var url = window.location.href;
            var segments = url.split('/');
            var lengthseg = url.endsWith('/') ? segments.length - 1 : segments.length;
            if (_this.editId === '-1') {
                _this.api.createBrandCategory(segments[lengthseg - 2], submittedCategories)
                    .then(function (response) {
                    var _a;
                    _this.toCategoriesPage((_a = _this.state.brandId) === null || _a === void 0 ? void 0 : _a.toString());
                })
                    .catch(function (error) {
                    var defaultMessage = 'Грешка при създаване на маркова категория';
                    _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
                });
            }
            else {
                console.log(segments[lengthseg - 3], segments[lengthseg - 1]);
                _this.api.updateBrandCategory(segments[lengthseg - 3], segments[lengthseg - 1], submittedCategories)
                    .then(function (response) {
                    var _a;
                    _this.toCategoriesPage((_a = _this.state.brandId) === null || _a === void 0 ? void 0 : _a.toString());
                })
                    .catch(function (error) {
                    var defaultMessage = 'Грешка при създаване на маркова категория';
                    _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
                });
                ;
            }
        };
        _this.toCategoriesPage = function (id) {
            _this.props.history.push(AppRoutes.brand.path + '/' + id + AppRoutes.brandCategories.path);
        };
        _this.toCategoriesPagee = function () {
            _this.props.history.push(AppRoutes.brand.path + '/' + _this.state.brandId + AppRoutes.brandCategories.path);
        };
        // searches through the api for category that has to be assigned as parent
        _this.getSuggestions = function (event) {
            _this.api
                .searchBrandCategory(event.query)
                .then(function (response) {
                _this.mapSuggestionsToField(_.get(response, 'data.data', []));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при търсене на категория';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.mapSuggestionsToField = function (rawData) {
            var controlSuggestions = rawData.map(function (item, key) {
                return new DropdownOption({
                    label: _.get(item, 'attributes.bg_name', ''),
                    value: _.get(item, 'id', '-1'),
                });
            });
            _this.setState({ parentSuggestions: controlSuggestions });
        };
        return _this;
    }
    BrandCategoryForm.prototype.componentDidMount = function () {
        var url = window.location.href;
        var segments = url.split('/');
        var lengthseg = url.endsWith('/') ? segments.length - 1 : segments.length;
        this.editId = _.get(this.props, 'match.params.id', '-1');
        if (this.editId !== '-1') {
            this.getCategory(segments[lengthseg - 3], this.editId);
            this.setState({
                categoryId: segments[lengthseg - 1],
                brandId: segments[lengthseg - 3],
            });
        }
        else {
            this.setState({
                brandId: segments[lengthseg - 2],
            });
        }
    };
    BrandCategoryForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, parentSuggestions = _a.parentSuggestions;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); }, completeMethod: _this.getSuggestions, suggestions: parentSuggestions }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toCategoriesPagee, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return BrandCategoryForm;
}(React.Component));
// @ts-ignore
export default withRouter(BrandCategoryForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Brands/BrandCategoryForm/BrandCategoryForm.tsx
// module id = 531
// module chunks = 0